import { Button, Pagination, Popconfirm, Select, Space, Tag, message } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

import AlarmEventApi from "../../../api/AlarmEventApi";
import DeviceApi from "../../../api/DeviceApi";
import StringUtils from "../../../util/StringUtils";
import moment from "moment";
import { AlarmEventOverviewWrapper, AlarmEventManagementWrapper, ToolBarWrapper, FilterBar, FilterItem, ButtonItem, AlarmEventCardWrapper ,AlarmEventCardsContainer, CardHeader, Name, InfoLabel, InfoValue, LastLine, ViewDetailButton, PaginationWrapper} from "./AlarmEventManagement.styled";
import TimeUtils from "../../../util/TimeUtils";
import { SearchOutlined } from "@ant-design/icons";
import AlarmEventOverview from "./conponents/device-overview/AlarmEventOverview";

interface AlarmEventManagementProps {

}

const AlarmEventManagement: React.FC<AlarmEventManagementProps> = (props)=> {
    // api
    let deviceApi = new DeviceApi();
    let alarmEventApi = new AlarmEventApi();
 
    // state
    let [loading, setLoading] = useState(false);
    let [deviceId, setDeviceId] = useState(null);
    let [acked, setAcked] = useState(false);
    let [startTime, setStartTime] = useState(null);
    let [endTime, setEndTime] = useState(null);
    let [tableParams, setTableParams] = useState<any>({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });
    
    let [deviceOptions, setDeviceOptions] = useState(null);
    let [alarmEventViews, setAlarmEventViews] = useState([]);

    // functions
    let loadDevices = async ()=> {
        let devices = (await deviceApi.getAll()).data.data;
        let deviceOptions = devices.map((e)=> {
            return {
                label: e.name,
                value: e.id,
            };
        });
        setDeviceOptions(deviceOptions);
    };

    let loadEventViews = async (opts?: { pageNo?: number, pageSize?: number })=> {
        // loading animation
        setLoading(true);
        
        // start/end time
        let startTimestamp = null;
        if (startTime!=null) {
            startTimestamp = dayjs(startTime).toDate().getTime();
        }
        let endTimestamp = null;
        if (endTime!=null) {
            endTimestamp = dayjs(endTime).toDate().getTime();
        }

        const pageNo = opts?.pageNo ?? (tableParams.pagination?.current || 1);
        const pageSize = opts?.pageSize ?? (tableParams.pagination?.pageSize || 10);

        let alarmEventViewsPage = (await alarmEventApi.queryViews({
            deviceId: deviceId,
            acked: acked,
            startTime: startTimestamp,
            endTime: endTimestamp,
            pageNo: pageNo,
            pageSize: pageSize,
        })).data.data;

        let newTableParams = {pagination: {...tableParams.pagination, current: pageNo, pageSize: pageSize}};
        newTableParams.pagination.total = alarmEventViewsPage.totalElements;
        setTableParams(newTableParams);
        setAlarmEventViews(alarmEventViewsPage.elements);
        setLoading(false);
    };

    // events
    let onDeviceChange=(selectedValue: string)=> {
        setDeviceId(selectedValue);
    };

    let onAckedChange=(selectedValue: any)=> {
        setAcked(selectedValue);
    };

    let onQueryButtonClick = async ()=> {
        const currentPageSize = tableParams.pagination.pageSize;
        setTableParams({pagination: {...tableParams.pagination, current: 1}});
        await loadEventViews({ pageNo: 1, pageSize: currentPageSize });
    };

    let onAckAlarmEvent = async (alarmEventView)=> {
        await alarmEventApi.ack(alarmEventView.event.id);
        message.success('事件标记成功');
        loadDevices();
        loadEventViews();
    };

    let onPaginationChange = (page: number, pageSize?: number) => {
        const newPagination = {
            ...tableParams.pagination,
            current: page,
            pageSize: pageSize || tableParams.pagination?.pageSize,
        };
        setTableParams({ pagination: newPagination });
        loadEventViews({ pageNo: page, pageSize: newPagination.pageSize });
        loadDevices();
    };

    // effect
    useEffect(()=> {
        loadDevices();
        loadEventViews();
    }, []);
    

    // render
    return (
        <AlarmEventManagementWrapper>
            <AlarmEventOverviewWrapper>
                <AlarmEventOverview/>
            </AlarmEventOverviewWrapper>
            <ToolBarWrapper>
                <FilterBar>
                    <Space size="small">
                        <FilterItem>
                            <Select
                                showSearch
                                allowClear
                                optionFilterProp="label"
                                filterSort={(a, b) => a <= b ? -1 : 1}
                                style={{ width: '170px' }}
                                placeholder="选择目标设备"
                                defaultValue={deviceId}
                                value={deviceId}
                                onChange={onDeviceChange}
                                options={deviceOptions}
                            />
                        </FilterItem>

                        <FilterItem>
                            <Select
                                showSearch
                                allowClear
                                optionFilterProp="label"
                                style={{ width: '110px' }}
                                placeholder="请选择事件状态"
                                defaultValue={acked}
                                value={acked}
                                onChange={onAckedChange}
                                options={[
                                    {label: '已处理', value: true},
                                    {label: '未处理', value: false}
                                ]}
                            />
                        </FilterItem>

                        <ButtonItem>
                            <Button 
                                size="small" 
                                shape="circle" 
                                icon={<SearchOutlined />} 
                                onClick={onQueryButtonClick}
                                className="query-button"
                            ></Button>
                        </ButtonItem>
                    </Space>
                    
                </FilterBar>
            </ToolBarWrapper>

            <AlarmEventCardsContainer>
                {loading ? (
                    <AlarmEventCardWrapper>
                        <div style={{textAlign: 'center', padding: '20px', color: '#8c8c8c'}}>
                            加载中...
                        </div>
                    </AlarmEventCardWrapper>
                ): alarmEventViews.length > 0 ? (
                alarmEventViews.map(record => (
                    <AlarmEventCardWrapper key={record.device.id}>
                        <CardHeader>
                            <Name>{StringUtils.emptyToSlash(record.device?.name)}</Name>
                            {
                               record.event.acked ? <Tag color="green">已处理</Tag> : <Tag color="red">未处理</Tag>
                            }                            
                        </CardHeader>
                        <InfoLabel>规则名称:</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(record.alarmRule?.name)}</InfoValue>
                        { record.event.acked &&<InfoLabel>处理时间</InfoLabel> }
                        { record.event.acked &&<InfoValue>{record.event.acked ? moment(parseInt(record.event.ackTime)).format('YYYY/MM/DD HH:mm:ss') : 'N/A'}</InfoValue>}
                        <InfoLabel>事件时间:</InfoLabel>
                        <InfoValue><span>{ moment(parseInt(record.event.startTime)).format("YYYY-MM-DD HH:mm:ss") }</span></InfoValue>
                        <InfoLabel>详情:</InfoLabel>
                        <InfoValue>{StringUtils.emptyToSlash(record.event?.details)}</InfoValue>
                        <InfoLabel>持续时间:</InfoLabel>
                        <LastLine>
                            <InfoValue><span>{ TimeUtils.durationToText(record.event.endTime - record.event.startTime) }</span></InfoValue>
                            {!record.event.acked &&  <ViewDetailButton>
                                { 
                                    <Popconfirm
                                        title="确定标记为已处理?"
                                        style={{marginRight: "20px"}}
                                        onConfirm={()=> onAckAlarmEvent(record)}
                                        okText="确定"
                                        cancelText="取消"
                                        >
                                        <a>标记为已处理</a>
                                    </Popconfirm>
                                }
                            </ViewDetailButton>}
                        </LastLine>
                    </AlarmEventCardWrapper>
                ))
                ) : (
                <div style={{gridColumn: '1 / -1', textAlign: 'center', padding: '40px', color: '#8c8c8c'}}>
                    暂无设备数据
                </div>
                )}
            </AlarmEventCardsContainer>
            
             {!loading && alarmEventViews.length > 0 && (
                <PaginationWrapper>
                    <Pagination
                        simple 
                        current={tableParams.pagination?.current}
                        pageSize={tableParams.pagination?.pageSize}
                        total={tableParams.pagination?.total}
                        onChange={onPaginationChange}
                        onShowSizeChange={(current, size) => onPaginationChange(1, size)}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => 
                            `第 ${range[0]}-${range[1]} 条/共 ${total} 条`
                        }
                    />
                </PaginationWrapper>
            )}
        </AlarmEventManagementWrapper>
    );
}

export default AlarmEventManagement;


